import { register } from 'register-service-worker';

// The ready(), registered(), cached(), updatefound() and updated()
// events passes a ServiceWorkerRegistration instance in their arguments.
// ServiceWorkerRegistration: https://developer.mozilla.org/en-US/docs/Web/API/ServiceWorkerRegistration

const emitWaitingEvent = async (registration) => {
  document.dispatchEvent(new CustomEvent('swUpdated', { detail: registration }));
};

register(process.env.SERVICE_WORKER_FILE, {
  // The registrationOptions object will be passed as the second argument
  // to ServiceWorkerContainer.register()
  // https://developer.mozilla.org/en-US/docs/Web/API/ServiceWorkerContainer/register#Parameter

  // registrationOptions: { scope: './' },

  ready() {
    if (process.env.DEV) {
      console.log('App is being served from cache by a service worker.'); // eslint-disable-line no-console
    }
  },

  registered(registration) {
    if (registration.waiting && registration.active) {
      // The page has been loaded when there's already a waiting and active SW.
      // This would happen if skipWaiting() isn't being called, and there are
      // still old tabs open.
      emitWaitingEvent(registration);
    }

    if (process.env.DEV) {
      console.log('Service worker has been registered.'); // eslint-disable-line no-console
    }
  },

  cached(/* registration */) {
    if (process.env.DEV) {
      console.log('Content has been cached for offline use.'); // eslint-disable-line no-console
    }
  },

  updatefound(registration) {
    if (process.env.DEV) {
      console.log('New content is downloading.'); // eslint-disable-line no-console
    }

    registration.installing.addEventListener('statechange', (event) => {
      if (event.target.state !== 'installed') {
        return;
      }

      // New SW is in waiting state
      emitWaitingEvent(registration);
    });
  },

  updated(/* registration */) {
    if (process.env.DEV) {
      console.log('New content is available; please refresh.'); // eslint-disable-line no-console
    }
  },

  offline() {
    if (process.env.DEV) {
      console.log('No internet connection found. App is running in offline mode.'); // eslint-disable-line no-console
    }
  },

  error(err) {
    if (process.env.DEV) {
      console.error('Error during service worker registration:', err);
    }
  },
});
